import { fetchData } from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";

export interface ColorRange {
    minValue: number;
    maxValue: number;
    color: string;
}

export interface Form30ColorSettings {
    _id: string;
    year: number;
    table_id: string;
    row_id: string;
    column_key: string;
    colors: ColorRange[];
    createdAt: string;
    updatedAt: string;
}

export interface Form30ColorSettingsResponse {
    success: boolean;
    data: Form30ColorSettings | null;
    message?: string;
    error?: string;
}

export interface SaveForm30ColorSettingsRequest {
    year: number;
    table_id: string;
    row_id: string;
    column_key: string;
    colors: ColorRange[];
}

/**
 * Получить настройки цветов для показателя
 */
export const getForm30ColorSettings = async (
    year: number,
    table_id: string,
    row_id: string,
    column_key: string
): Promise<Form30ColorSettingsResponse> => {
    const url = `/form30-colors?year=${year}&table_id=${table_id}&row_id=${row_id}&column_key=${column_key}`;
    
    const response = await fetchData(url, {
        method: "GET",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        }
    }, 2);

    return response.json();
};

/**
 * Сохранить настройки цветов
 */
export const saveForm30ColorSettings = async (
    data: SaveForm30ColorSettingsRequest
): Promise<Form30ColorSettingsResponse> => {
    const response = await fetchData('/form30-colors', {
        method: "POST",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
    }, 2);

    return response.json();
};
